import { useState } from 'react';

import { useServerClient } from '../useServerClient';
import { useServerParams } from '../useServerParams';

export const groupTypes = {
    supplier: "supplier",
    customer: "customer",
    administrator: "administrator"
}

export const targetTypes = {
    supplier: "supplier",
    customer: "customer",
    administrator: "administrator"
}

export const scopeTypes = {
    administrator: [
        {
            id: "access_route",
            name: "Access Route",
            isDefault: true
        }
    ],
    customer: [
        {
            id: "group_price",
            name: "Group Price",
            isDefault: true
        },
        {
            id: "delivery_remark",
            name: "Delivery Remark",
            isDefault: false
        },
        {
            id: "logistic_rate",
            name: "Logistic Rate",
            isDefault: false
        }
    ],
    supplier: [
        {
            id: "default",
            name: "Default",
            isDefault: true
        }
    ]
}

export function useGroups({
    groupType: _groupType, 
    targetType: _targetType
}) {

    const [ groupType, setScopeType ] = useState(_groupType);
    const [ targetType, setTargetType ] = useState(_targetType);

    const { makeCall, getError } = useServerClient();
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [ isLoading, setIsLoading ] = useState(false)

    const endpoint1 = "group";
    const endpoint2 = "groups"

    const list = async (props) => {

        setIsLoading(true);

        try{

            let url = getListsUrl(`${endpoint2}/${groupType}`, props);

            if(targetType){
                url = getListsUrl(`${endpoint2}/${groupType}/${targetType}`, props);
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });
            
            setIsLoading(false);

            return response;

        }catch(error){

            setIsLoading(false);
            throw error;

        }
    }

    const create = async ({ data, groupType: _groupType, targetType: _targetType }) => {

        setIsLoading(true)

        try{

            let url = `${endpoint1}`;

            if(_groupType){
                url = `${endpoint1}/${_groupType}`;
            }

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if(_targetType) postData.scope.target = _targetType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        }catch(error){

            setIsLoading(false);
            throw error;

        }

    }

    const update = async ({ id, data, groupType: _groupType, targetType: _targetType }) => {

        setIsLoading(true)

        try{

            let url = `${endpoint1}/${id}`
            
            if(_groupType){
                url = `${endpoint1}/${_groupType}/${id}`
            }

            const postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if(_targetType) postData.scope.target = _targetType
            
            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        }catch(error){

            setIsLoading(false);
            throw error;

        }

    }

    const remove = async ({ ids, groupType: _groupType, targetType: _targetType }) => {

        setIsLoading(true);

        if(ids.length <= 0){
            throw getError(false, `Please select at least (1) items`)
        }

        try{

            let url = `${endpoint2}/delete`

            if(_groupType){
                url = `${endpoint1}/${_groupType}/delete`
            }

            const postData = {
                scope: {
                    target: targetType
                },
                payload: {
                    ids
                }
            }

            if(_targetType) postData.scope.target = _targetType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        }catch(error){

            setIsLoading(false);
            throw error;

        }

    } 

    const get = async ({ id, dataTypesArray = [] }) => {

        setIsLoading(true);

        try{

            let url = getUrlWithDataTypes(`${endpoint1}/${groupType}/${id}`, dataTypesArray)

            if(targetType){
                url = getUrlWithDataTypes(`${endpoint1}/${groupType}/${targetType}/${id}`, dataTypesArray)
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        }catch(error){

            setIsLoading(false);
            throw error;

        }

    } 

    return { 
        isLoading,
        filterOperatorTypes,
        groupTypes,
        targetTypes,
        list,
        get, 
        create,
        update, 
        remove 
    }
}